import React from 'react';
import { __ } from '@wordpress/i18n';
import FacetContainer from '../customFacet';
import FilterSummary from '../facet/FilterSummary';
import { getRegionLabels } from '../facet/regionLabels';
import { getInitialMarket, getListingBaseUrl } from '../facet/urlLocale';

const hasInitialMarket = !!getInitialMarket();

const MobileFilterMenu = () => (
    <div className="mobile-filters">
      {/* Filter menu open button */}
      <div className="filter-bar__combined-menu" id="filter-bar__combined-menu">
        <a className="filter-bar__combined-menu__a erase-trace" href="#filter-bar__menu">
          <span className="filter-bar__text-label-mobile job-filter-counter--number">{__('Filters', 'wp-plugin-jobs')}</span>
          <span className="filter-bar__filter-icon"></span>
        </a>
      </div>
      {/* Mobile filter drawer */}
      <div className="filter-bar__menu filter-bar__menu--job" id="filter-bar__menu">
        <div className="filter-bar__header-mobile">
          <a
            className="filter-bar__header-mobile__close-icon erase-trace "
            href="#filter-bar__content"
            aria-label={__('Close', 'wp-plugin-jobs')}
          ></a>
        </div>
        <FilterSummary className="filter-summary"></FilterSummary>
        <FacetContainer key={'5'} field={'region.keyword'} label={__('Region', 'wp-plugin-jobs')} valueLabels={getRegionLabels()} defaultOpen />
        <FacetContainer key={'1'} field={'market.keyword'} label={__('Location', 'wp-plugin-jobs')} defaultOpen={hasInitialMarket} />
        <FacetContainer key={'6'} field={'job_hours.keyword'} label={__('Hours', 'wp-plugin-jobs')} />
        <FacetContainer key={'2'} field={'placement_type.keyword'} label={__('Placement type', 'wp-plugin-jobs')} />
        <FacetContainer key={'4'} field={'offsite_preference.keyword'} label={__('Location preference', 'wp-plugin-jobs')} />
      </div>
      {/* Mobile footer buttons */}
      <div className="filter-bar__dropdown-buttons-mobile has-core-black-background-color">
        <a className="tertiary-info erase-trace" href={getListingBaseUrl()}>{__('Clear all', 'wp-plugin-jobs')}</a>
        <div className="wp-block-button a-button">
          <button
            className="a-button__link__text default-text"
            onClick={() => window.location.replace('#filter-bar__content')}
          >
            {__('Show Results', 'wp-plugin-jobs')}
          </button>
        </div>
      </div>
    </div>
);
export default MobileFilterMenu;
